import { IGif } from '@giphy/js-types'
import React, { useState, useEffect } from 'react'
import { searchClips } from 'shared/api'
import SharedCarousel from 'shared/components/carousel/carousel'
import SharedVideoPreview from 'shared/components/video-preview-thumbnail'
import styled from 'styled-components'
import { giphyWhite } from '@giphy/js-brand'
import { gridWidth } from 'shared/util/grid'

const MARGIN = 16
const MAX_CAROUSEL_ITEMS = 4

const Carousel = styled(SharedCarousel)`
    margin-bottom: 15px;
    & h2 {
        color: ${giphyWhite};
        font-size: 17px;
        font-weight: bold;
        letter-spacing: 0.3px;
        font-family: InterFace;
    }
    & h3 {
        font-family: interface;
        font-weight: bold;
        box-shadow: 0px 2px 24px 0px rgba(0, 0, 0, 0.25);
    }
`

const VideoPreview = styled(SharedVideoPreview)`
    display: inline-block;
    margin-bottom: ${MARGIN}px;
    margin-right: ${MARGIN}px;
    &:nth-${`child(${MAX_CAROUSEL_ITEMS}n)`} {
        margin-right: 0;
    }
`

const getItemWidth = (width: number) => {
    const margin = (MAX_CAROUSEL_ITEMS - 1) * MARGIN
    return Math.floor((width - margin) / MAX_CAROUSEL_ITEMS)
}

type Props = {
    term: string
}

const ClipsCarousel = ({ term }: Props) => {
    const [clips, setClips] = useState<IGif[]>([])
    const itemWidth = getItemWidth(gridWidth)
    useEffect(() => {
        !clips.length && fetchClips(term)
    }, [])

    const fetchClips = async (term: string) => {
        const { data } = await searchClips({ q: term, limit: 50 })
        setClips(data)
    }
    return (
        !!clips.length && (
            <Carousel maxBlocks={MAX_CAROUSEL_ITEMS} title={`GIPHY Clips`}>
                {clips.map((gif: IGif) => (
                    <VideoPreview
                        key={gif.id}
                        gif={gif}
                        width={itemWidth}
                        hideAttribution={true}
                        preventDefault={false}
                        hideLabel
                    />
                ))}
            </Carousel>
        )
    )
}

export default ClipsCarousel
